import { Controller } from "@hotwired/stimulus"

// Native <dialog>'s backdrop is part of the dialog element itself — there is
// no separate node to attach an "outside click" listener to. So instead of
// checking event.target (a click on the dialog's own padding would also
// equal the dialog element and get treated as "outside"), compare the click's
// coordinates against the dialog's box: inside is content, outside is
// backdrop. One controller instance per <dialog>, so this works correctly
// even when several are mounted on the same page.
//
// Escape needs no handling here — showModal() gives that for free.
export default class extends Controller {
  dismiss(event) {
    const rect = this.element.getBoundingClientRect()
    const inBounds =
      event.clientX >= rect.left && event.clientX <= rect.right &&
      event.clientY >= rect.top && event.clientY <= rect.bottom
    if (!inBounds) this.element.close()
  }
}
